import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as Dialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import { cn } from '../utils/cn.js';
/**
 * Modal — wraps Radix Dialog so we get focus trapping, ESC dismiss,
 * scroll lock, and ARIA wiring for free.
 *
 * UX rule: only ONE modal on screen at any time (CHARTE §10.4).
 */
export function Modal({ open, onOpenChange, title, description, closeLabel, children, className, }) {
    return (_jsx(Dialog.Root, { open: open, onOpenChange: onOpenChange, children: _jsxs(Dialog.Portal, { children: [_jsx(Dialog.Overlay, { className: "clari-modal-overlay" }), _jsxs(Dialog.Content, { className: cn('clari-modal-content', className), children: [_jsxs("div", { className: "clari-modal__header", children: [_jsx(Dialog.Title, { className: "clari-modal__title", children: title }), _jsx(Dialog.Close, { className: "clari-modal__close", "aria-label": closeLabel, children: _jsx(X, { size: 20, strokeWidth: 1.5 }) })] }), description ? (_jsx(Dialog.Description, { className: "clari-modal__description", children: description })) : null, children] })] }) }));
}
//# sourceMappingURL=Modal.js.map